import React, { useEffect } from "react";

import Main from '../components/BonusSystem/Main'
import ExceptionalBonuses from "../components/BonusSystem/ExceptionalBonuses";
import SimpleSteps from "../components/Home/SimpleSteps";

function Fees () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#E6E3E6]">
            <Main/>
            <ExceptionalBonuses/>
            <SimpleSteps/>
        </div>
    );
}

export default Fees;